import type { UpdateOrganizationDTO } from "@src/domain/dto/organizations";
import type { Organization } from "@src/domain/entities/organization";
import type { IOrganizationRepository } from "@src/domain/repositories/organization";

export class UpdateOrganizationUseCase {
  private readonly organizationRepository: IOrganizationRepository;

  constructor(organizationRepository: IOrganizationRepository) {
    this.organizationRepository = organizationRepository;
  }

  async execute(params: UpdateOrganizationDTO): Promise<Organization> {
    return this.organizationRepository.updateOrganization(params);
  }
}
